<template>
  <div class="hidden md:flex items-center h-full top-0 right-0 pe-3 absolute">
    <img :src="`https://s3.us-central-1.wasabisys.com/tf-public-dl/sara/assets/login_side_image?v=${ver}`"
         class="rounded-xl h-[95vh] object-cover">
  </div>
</template>

<script setup>
import {DateTime} from "luxon";

const ver = DateTime.now().toFormat('yyyy-MM-dd');
</script>
